import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AvisGoogleDetailsComponent } from '@components/avis-google-details';
import { AvisGoogleDetails } from '@components/avis-google-details/models';
import { PopinContainerComponent } from '@shared/components/popin-container';

@Component({
  imports: [PopinContainerComponent, AvisGoogleDetailsComponent],
  templateUrl: './popin-avis-google-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinAvisGoogleDetailsComponent {
  data = inject(DIALOG_DATA) as AvisGoogleDetails;
}
